const mapData = {

    fullMapCoords: 
        [
            {
                "location": "Illinois, Washington, DC",
                "coordinates": ["top: 41%; left: 61.5%;"]
            },
            {
                "location": "Illinois, Missouri, Washington, DC",
                "coordinates": ["top: 41%; left: 61.5%;"]
            },
            {
                "location": "DC",
                "coordinates": ["top: 43.7%; left: 83.15%;"]
            },
            {
                "location": "Dorchester County, MD",
                "coordinates": ["top: 42.0%; left: 85.5%;"]
            },
            {
                "location": "Annapolis, MD",
                "coordinates": ["top: 41.5%; left: 84.0%;"]
            },
            {
                "location": "Gettysburg",
                "coordinates": ["top: 36.6%; left: 71.65%;"]
            },
            {
                "location": "Auburn, NY",
                "coordinates": ["top: 25.1%; left: 82.7%;"]
            },
            {
                "location": "Detroit",
                "coordinates": ["top: 30.4%; left: 71.1%;"]
            },
            {
                "location": "Chicago",
                "coordinates": ["top: 34.1%; left: 62.9%;"]
            },
            {
                "location": "Harper's Ferry, WV",
                "coordinates": ["top: 41.5%; left: 80.65%;"]
            },
            {
                "location": "Havana Harbor",
                "coordinates": ["top: 69.7%; left: 87.6%;"],
                "arrow": "south"
            },
            {
                "location": "Port-Au-Prince, Haiti",
                "coordinates": ["top: 69.7%; left: 87.6%;"],
                "arrow": "south"
            },
            {
                "location": "Arizona, California, Colorado, Nevada, New Mexico, Utah and Wyoming",
                "coordinates": ["top: 41%; left: 45.8%;"],
                "arrow": "west"
            },
            {
                "location": "Wyoming",
                "coordinates": ["top: 31%; left: 32%;"]
            },
            {
                "location": "American South",
                "coordinates": ["top: 64%; left: 73%;"]
            },
            {
                "location": "Pulaski, Tennessee",
                "coordinates": ["top: 57.9%; left: 68.6%;"]
            },
            {
                "location": "New York Harbor",
                "coordinates": ["top: 33.57%; left: 80.6%;"]
            },
            {
                "location": "South Carolina",
                "coordinates": ["top: 61%; left: 79%;"]
            },
            {
                "location": "Virginia",
                "coordinates": ["top: 47.9%; left: 80.7%;"]
            },
            {
                "location": "Meredith, New Hampshire",
                "coordinates": ["top: 21.4%; left: 90.77%;"]
            },
            {
                "location": "Canada",
                "coordinates": ["top: 6.5%; left: 68.7%;"]
            },
            {
                "location": "New Bedford, MA",
                "coordinates": ["top: 27.4%; left: 93.25%;"]
            },
            {
                "location": "Rochester, NY",
                "coordinates": ["top: 26.1%; left: 79.8%;"]
            },
            {
                "location": "Arizona",
                "coordinates": ["top: 23.7%; left: 7%;"],
                "arrow": "west"
            },
            {
                "location": "California",
                "coordinates": ["top: 23.7%; left: 7%;"],
                "arrow": "west"
            },
            {
                "location": "Nevada",
                "coordinates": ["top: 23.7%; left: 7%;"],
                "arrow": "west"
            },
            {
                "location": "New Mexico",
                "coordinates": ["top: 23.7%; left: 7%;"],
                "arrow": "west"
            },
            {
                "location": "Utah",
                "coordinates": ["top: 23.7%; left: 7%;"],
                "arrow": "west"
            },
            {
                "location": "Seneca Falls, NY",
                "coordinates": ["top: 26.7%; left: 81.3%;"]
            },
            {
                "location": "Ireland, Scotland, England",
                "coordinates": ["top: 69.7%; left: 87.6%;"],
                "arrow": "east"
            },
            {
                "location": "Boston, MA",
                "coordinates": ["top: 24.2%; left: 92.2%;"]
            },
            {
                "location": "New York",
                "coordinates": ["top: 24.9%; left: 84.7%;"]
            },
            {
                "location": "Nantucket, MA",
                "coordinates": ["top: 27.6%; left: 94.5%;"]
            },
            {
                "location": "Europe",
                "coordinates": ["top: 69.7%; left: 87.6%;"],
                "arrow": "east"
            },
            {
                "location": "US to Europe",
                "coordinates": ["top: 69.7%; left: 87.6%;"],
                "arrow": "east"
            },
            {
                "location": "Baltimore, MD",
                "coordinates": ["top: 39.5%; left: 84.2%;"]
            },
            {
                "location": "Southampton County, VA",
                "coordinates": ["top: 49.9%; left: 84%;"]
            },
            {
                "location": "West of Mississippi River",
                "coordinates": ["top: 58%; left: 65%;"],
                "arrow": "west"
            },
            {
                "location": "Midwest",
                "coordinates": ["top: 38%; left: 61%;"]
            },
            {
                "location": "Southern United States",
                "coordinates": ["top: 59.8%; left: 48.5%;"],
                "arrow": "south"
            },
            {
                "location": "Burgundy, France, England",
                "coordinates": ["top: 69.7%; left: 87.6%;"],
                "arrow": "east"
            },
            {
                "location": "Somerville, MA",
                "coordinates": ["top: 23.1%; left: 92.2%;"]
            },
            {
                "location": "Maryland",
                "coordinates": ["top: 40%; left: 84.7%;"]
            },
            {
                "location": "MD to PA",
                "coordinates": ["top: 39.4%; left: 82.8%;"]
            },
            {
                "location": "Philadelphia, PA",
                "coordinates": ["top: 36.4%; left: 86%;"]
            },
            {
                "location": "Lynn, MA",
                "coordinates": ["top: 24%; left: 92.2%;"]
            },
            {
                "location": "Talbot County, MD",
                "coordinates": ["top: 41%; left: 85.2%;"]
            },

            /*
            {
                "location": "Louisiana",
                "coordinates": ["top: 74.4%; left: 31%;"]
            },
            {
                "location": "Massachusetts",
                "coordinates": ["top: 26.9%; left: 82.7%;"]
            },
            {
                "location": "Pennsylvania",
                "coordinates": ["top: 35.4%; left: 67.5%;"]
            },
            {
                "location": "Cleveland, OH",
                "coordinates": ["top: 33.3%; left: 58.67%;"]
            },
            {
                "location": "Scotland",
                "coordinates": ["top: 69.7%; left: 87.6%;"],
                "arrow": "east"
            },
            {
                "location": "France",
                "coordinates": ["top: 69.7%; left: 87.6%;"],
                "arrow": "east"
            },
            {
                "location": "England",
                "coordinates": ["top: 69.7%; left: 87.6%;"],
                "arrow": "east"
            },
            {
                "location": "Ireland",
                "coordinates": ["top: 69.7%; left: 87.6%;"],
                "arrow": "east"
            },
            {
                "location": "Paris",
                "coordinates": ["top: 69.7%; left: 87.6%;"],
                "arrow": "east"
            },
            {
                "location": "Long Island, NY",
                "coordinates": ["top: 32.8%; left: 83.4%;"]
            },
            {
                "location": "Roanoke Island",
                "coordinates": ["top: 51.9%; left: 79.9%;"]
            },
            {
                "location": "New Bern",
                "coordinates": ["top: 54.8%; left: 76.2%;"]
            },
            {
                "location": "Savannah, Georgia",
                "coordinates": ["top: 71.57%; left: 65.1%;"]
            },
            */
        ]
}

export default mapData;